module.exports = __webpack_public_path__ + "static/media/white_compact_word_logo.e39f7d8e.png";